module.exports = __webpack_public_path__ + "img/accesscontrolBanner.50bf2c56.png";